
import PhotoThumbnail from './components/PhotoThumbnail';

export default {
  i18nComponentKey: 'WidgetProductReviewsPhotoThumbnail.WidgetProductReviewsPhotoThumbnailPc',
  name: 'WidgetProductReviewsPhotoThumbnailPc',
  components: { PhotoThumbnail }
};
